import styled from 'styled-components';
import { Button } from '@material-ui/core';

export default styled(Button)`
  margin: 18px;
  margin-top: 0;
`;
